export class PayStubService {
    constructor($http, $q, apexApiUrl, utilityService) {
        'ngInject'
        this.$http = $http;
        this.$q = $q;
        this.apexApiUrl = apexApiUrl;
        this.utilityService = utilityService;
    }

    /**
     * Retrieve the list of available pay stubs for the given employee.
     */
    retrievePayStubs(employeeID) {
        if (!employeeID) {
            return this.$q.when([]);
        }

        return this.$http({
            method: "GET",
            url: `${this.apexApiUrl}/pay-stubs/employee/${employeeID}`,
            headers: { Accept: "application/json" }
        })
            .then(function (response) {
                return response.data;
            });

    }

    /**
     * Retrieve the pay stub for the given pay week, belonging to either the given employee
     * (if the user has access to it) or the employee who is currently authenticated.
     */
    retrievePayStub(payrollID, employeeID, icdCorporationID) {
        return this.$http({
            method: "GET",
            url: `${this.apexApiUrl}/pay-stubs/employee/${employeeID}/week/${payrollID}`,
            params: {
                icdCorporationID
            },
            headers: { Accept: "application/json" }
        })
            .then(function (response) {
                return response.data;
            });
    }

    exportPayStubPdf(payrollID, employeeID, icdCorporationID, isPayStub) {
        const params = {
            icdCorporationID,
            isPayStub
        };
        const queryString = this.utilityService.queryStringify(params);
        window.location = `${this.apexApiUrl}/pay-stubs/employee/${employeeID}/week/${payrollID}.pdf`
            + queryString;
    }

    exportPayStubEarningsStatementPdf(payPeriodID) {
        window.location = `${this.apexApiUrl}/payroll-entries/${payPeriodID}/manual-submission/`
            + `/earnings-statement.pdf`;
    }
}
